/* global jQuery, elementorFrontend, js_vars */
( function( $ ) {
	$( window ).on( 'elementor/frontend/init', () => {

		/*--------------------------------------------------------------------------------
		Revive Content Switcher
		--------------------------------------------------------------------------------*/

		/**
		* @param $element The widget wrapper element as a jQuery element
		* @param $ The jQuery alias
		*/
		const reviveContentSwitcherHandler = ( $element, $ ) => {
			$element.find('.nav__entry').click(function(e){
				let $this = $(this);
				let content_id = $this.data('contentid');
				
				$element.find('.content__entry, .nav__entry').removeClass('active');
				$element.find(content_id).addClass('active');
				$this.addClass('active');
			});
		};

		elementorFrontend.hooks.addAction( 'frontend/element_ready/revive-contentswitcher.default', reviveContentSwitcherHandler );


		/*--------------------------------------------------------------------------------
		Revive Resources
		--------------------------------------------------------------------------------*/
		elementorFrontend.on('components:init', function() {

			// Reset form on load
			let searchForm = document.getElementById("live-search-form");
			if( searchForm) {
				searchForm.reset();
			}

			// Prep for direct-link resource filtering
			const url = new URL(window.location);
			const params = new URLSearchParams(url.search);

			// Manage search form submissions
			$(document).on('submit', '#live-search-form', function(e) {
				e.preventDefault();
				_submit_live_search( $(this) );
			});

			// Manage load more button
			$(document).on( 'click', '#loadmore', function(e) {
				e.preventDefault();

				var search_data = $('#live-search-form').serializeArray();
				var search_perpage = $('#live-search-form').data('perpage');
				var search_template = $('#live-search-form').data('view');
				var search_type = $('#live-search-form').data('searchtype');
				var page = $(this).data('page');

				if ( doAction ) {
					clearTimeout( doAction );
				}

				doAction = setTimeout( function() {
					_do_live_search(search_data, page, search_type, search_template, search_perpage);
				}, 250 );
			});
		});


		/*--------------------------------------------------------------------------------
		Form Components
		--------------------------------------------------------------------------------*/

		elementorFrontend.on('components:init', function() {

			// Display dropdown when clicked
			// $('.search-filter--dropdown .dropdown__title, .search-filter--dropdown_states .dropdown__title').click(function(e){
			// 	e.preventDefault();

			// 	// Handle outside clicks
			// 	let $parent = $(this).parent('.search-filter');
			// 	$parent.toggleClass('open');
			// 	hideOnClickOutside($parent);
			// });

			// Swap dropdown title when an option is selected, submit form
			// $(document).on( 'change', '.search-filter--dropdown .dropdown__content', function(e) {
			// 	let target = $(e.target),
			// 	dropdown_label = target.data('label');
			// 	target.parents('.search-filter--dropdown').removeClass('open').find('.dropdown__title').text(dropdown_label);

			// 	// Reset category radio & search text
			// 	$('input[name=taxonomy-category]')[0].checked = true;
			// 	$('#live-search').val('');

			// 	// Set URL, submit form
			// 	window.history.pushState('Resources', '', '/resources/');
			// 	target.parents('.live-search-form').submit();
			// });

			$(document).on( 'change', '.search-filter--radio', function(e) {
				let target = $(e.target),
				slug = target.data('slug');

				// Set URL, submit form
				if( slug == 'all' ) {
					// window.history.pushState('Resources', '', '/resources/');
				} else {
					// window.history.pushState('Resources', '', '/resources/' + slug);
				}
				
				target.parents('.search-filter--radio').find('input[type="radio"').removeClass('active');
				target.addClass('active');
				target.parents('.live-search-form').submit();
			});

			$(document).on( 'click', '.search-filter--radio input[type="radio"]', function(e) {
				if( $(this).hasClass('active') ) {
					$(this).removeClass('active').prop('checked', false);
					$(this).parents('.search-filter--radio').trigger('change');
				}
			});

			$(document).on( 'click', '.search-filter--submit', function(e) {
				let target = $(e.target);
				target.parents('.live-search-form').submit();
			});
		});


		/*--------------------------------------------------------------------------------
		Manage live search functionality
		--------------------------------------------------------------------------------*/
		let doAction = false,
		willDestroy = true,
		ajaxOn = 'inactive';

		function getNestedValue( obj, ...args ) {
			return args.reduce((obj, level) => obj && obj[level], obj)
		}

		function _submit_live_search( $form ) {
			var search_ctaid = $('#live-search-form').data('ctaid');
			var search_data = $form.serializeArray();
			var search_perpage = $form.data('perpage');
			var search_template = $form.data('view');
			var search_term = $('#live-search').val();
			var search_type = $form.data('searchtype');

			if( doAction ) {
				clearTimeout( doAction );
			}

			doAction = setTimeout( function() {
				_do_live_search(search_data, 1, search_type, search_template, search_perpage, search_ctaid);
			}, 250 );
		}

		// Execute search
		function _do_live_search( search_data, page = 1, search_type = '', template = 'card', perpage = 8 ) {
			// Exit if AJAX is currently running
			if ( ajaxOn == 'active' ) { return false; }

			$('.live-search-container').addClass('processing');

			// Run AJAX search
			ajaxOn = 'active';
			$.when( _ajax( search_data, page, search_type, template, perpage) ).done(function( response ) {
				// Handle post-search cleanup & display
				_do_after_search(search_data, response, page, template);
			});
		}

		// Process AJAX
		function _ajax( search_data, page = 1, search_type, template = 'card', perpage = 8 ) {
			var data = {
				action: 'revive_ajax_search',
				page: page,
				perpage: perpage,
				settings: search_data,
				searchtype: search_type,
				template: template
			};

			console.log(data);

			return $.ajax({
				type: 'POST',
				url: js_vars.ajaxurl,
				data: data,
				success: function(response) {
					// console.log(response);
					ajaxOn = 'inactive';
				},
				error: function(error) {
					console.log('error');
					ajaxOn = 'inactive';
				}
			});
		}

		// Handle results after search
		function _do_after_search(data, response, page = 1, template = 'card') {
			$('.live-search-container').removeClass('processing');

			_build_results(data, response, page, template);
			doAction = false;
		}

		// Destroy search results and/or button
		function _destroy( page = 1 ) {
			if( page !== 1 ) {
				$('#loadmore').remove();
			} else {
				$('#live-search-results').empty();
			}
		}

		// Display results
		function _build_results(search_data, response, page = 1, template = 'card') {
			if ( response.results.length > 0 ) {
				_destroy( page );
				let number_results = ( response.numberposts < response.perpage ) ? response.numberposts : ( response.perpage * page );
				$('.live-search-count').text('Showing ' + number_results + ' of ' + response.numberposts + ' results');

				$('#live-search-results').append(response.results);

				let more_pagination = getNestedValue(response, 'pagination', 'more');
				if( more_pagination !== undefined ) {
					$('#live-search-loadmore').html('<a id="loadmore" href="#" data-page="' + response.pagination.page + '">Load More</a>');
				} else {
					$('#live-search-loadmore').html('');
				}
			} else {
				_destroy();
				$('.live-search-count').text('');
				$('#live-search-results').append('<p class="noresults">No results found.</p>');
				$('#live-search-loadmore').html('');
			}

			$('#filters__active').html(response.active_filters);
			if( response.active_filter_count > 0 ) {
				$('#mobile-filters__clear').text('Clear (' + response.active_filter_count + ')');

				if( $('#clear-button--mobile').length ) {
					$('#clear-button--mobile').html('Clear (' + response.active_filter_count + ')');
				} else {
					$('#mobile-filter-controls').append('<a id="clear-button--mobile" class="clear-button--mobile" href="#">Clear (' + response.active_filter_count + ')</a>');
				}
			} else {
				$('#clear-button--mobile').remove();
				$('#mobile-filters__clear').text('Clear');
			}

			// Recalculate sticky header defined in theme, if necessary
			if( window.stickyHeader ) {
				window.stickyHeader.update();
			}
		}

	} );
} )( jQuery );
